import styled from 'styled-components';
import Link from 'gatsby-link';

export default styled(Link)`
  text-decoration: none;
  color: inherit;
  &.active {
    text-decoration: underline;
  }
`;



// WEBPACK FOOTER //
// ./src/components/primitives/StyledLink.js